// 角色管理
export default {
    role: 'Роль',
    roleName: 'Имя роли',
    roleDescription: 'Описание роли',
    userNumber: 'Номер пользователя',
    editRole: 'изменить роль',
    addRole: 'Добавить роль',
    rolePermissions: 'Разрешения ролей',
    tip_delete: 'После удаления персонажа его нельзя восстановить, действуйте осторожно!<br/>（Первоначальный пользователь этой роли имеет только функцию просмотра домашней страницы.）',
}